export default __webpack_public_path__ + "static/media/banner.f612929d.png";